import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DocServeService {
	redactionImageTab = 'AngularRedactionImage';
	annotationImageTab = 'AngularAnnotationImage';

	constructor(private http: HttpClient) {
	}

	getRedactionImage(docId: string, pageIndex: number): Observable<Blob> {
		const imageUrl = `/api2/doc-serve?DocId=${docId}&p=${pageIndex}&tab=${this.redactionImageTab}&toolbar=0&navpanes=0`;
		return this.http.get(imageUrl, {responseType: 'blob'});
	}

	getAnnotationImage(docId: string, pageIndex: number): Observable<Blob> {
		const imageUrl = `/api2/doc-serve?DocId=${docId}&p=${pageIndex}&tab=${this.annotationImageTab}&toolbar=0&navpanes=0`;
		return this.http.get(imageUrl, {responseType: 'blob'});
	}
}
